import "./ProcessingCharges.scss";
import { bankDetails, publicationFeeDetails } from './processingChargesData';

const ProcessingCharges = () => {
    return (
        <section className="processingChargesMainContainer">

            {/* First Row */}
            <article className="articleProcessingChargeParent">
                <div className="firstRow">
                    <h3>Article Processing Charge</h3>
                </div>
                <table className="secondRow">
                    <tbody style={{ width: "100%", display: "flex", flexDirection: "column", gap: "clamp(1.7575rem, 2.5vw, 3.2rem)" }}>
                        <tr className="firstColumn">
                            <td className="articleProcessingChargeTitles">
                                <h4 style={{ width: "100%", minWidth: "fit-content", whiteSpace: "nowrap" }}>Indian Authors</h4>
                            </td>
                            <td className="articleProcessingChargeValues">
                                <div style={{ display: "flex", minWidth: "fit-content", width: "100%", justifyContent: "space-between" }}>
                                    <h4 style={{ width: "7%", minWidth: "17.5px", margin: "0px" }} className="colon">:</h4>
                                    <h4 style={{ minWidth: "fit-content", width: "93%", whiteSpace: "nowrap" }}>₹ 1500 for each author + 18% GST</h4>
                                </div>
                            </td>
                        </tr>
                        <tr className="secondColumn">
                            <td className="articleProcessingChargeTitles">
                                <h4 style={{ width: "100%", minWidth: "fit-content", whiteSpace: "nowrap" }}>Non-Indian Authors</h4>
                            </td>
                            <td className="articleProcessingChargeValues">
                                <div style={{ display: "flex", minWidth: "fit-content", justifyContent: "space-between", width: "100%" }}>
                                    <h4 style={{ width: "7%", minWidth: "17.5px", margin: "0px" }} className="colon">:</h4>
                                    <h4 style={{ minWidth: "fit-content", width: "93%", whiteSpace: "nowrap", margin: "0" }}>$ 50 for each Author</h4>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </article>

            {/* Second Row */}
            <article className="publicationFeeParent">
                {publicationFeeDetails.map((feeDetail, index) => (
                    <div>
                        <h4>{feeDetail.title}</h4>
                        <ul>
                            {feeDetail.points.map((point, index) => (
                                <li key={index}>{point}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </article>

            {/* Third Row */}
            <article className="bankDetailsParent">
                {bankDetails.map((detail, index) => (
                    <div key={index} style={{ display: "flex", flexDirection: "column", gap: "clamp(12.5px, 5vw, 37.5px)" }}>
                        <h3>{detail.title}</h3>
                        <ul style={{ display: "flex", flexDirection: "column", gap: "clamp(10px, 4vw, 30px)" }}>
                            {detail.points.map((point, index) => (
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <h4 key={index} style={{ width: "30%", minWidth: "fit-content", minWidth: "117.5px", fontSize: "var( --h4-font-size)", fontFamily: "var(--font-h4)" }} className="bankDetailsTitle">{point.title}</h4>
                                    <div style={{ display: "flex", minWidth: "fit-content", width: "65%", justifyContent: "space-around" }}>
                                        <h4 style={{ width: "9%", minWidth: "17.5px", fontSize: "var( --h4-font-size)", fontFamily: "var(--font-h4)" }} className="colon">:</h4>
                                        <h4 key={index} style={{ minWidth: "fit-content", width: "91%", whiteSpace: "nowrap", fontSize: "var( --h4-font-size)", fontFamily: "var(--font-h4)" }} className="bankDetailsValues">{point.value}</h4>
                                    </div>
                                </div>
                            ))}
                        </ul>
                    </div>
                ))}
            </article>

            {/* Fourth Row */}
            <article className="contantDetailsParent">
                <p><strong>Note:</strong> Payment receipts of accepted paper must be forwarded to njsch@nicollege.com</p>
                <p><strong>For queries, please contact:</strong></p>
                <p><strong>Dr. R. Rajalakshmi<br></br>Assistant Professor & Head<br></br>Department of Computer Science<br></br>(+91 9600802980)</strong></p>
                <br></br>
                <p><strong>Mrs. V. Meera Sabari<br></br>Assistant Professor<br></br>Department of  Biotechnology<br></br>(+91 7358416061)</strong></p>
            </article>

        </section>
    )
}

export default ProcessingCharges
